import {Button} from "../../../basic/button.tsx";
import {Plus} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface TeamActionsProps {
    totalTeams: number;
    onCreateTeam: () => void;
}

export function TeamActions({totalTeams, onCreateTeam}: TeamActionsProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="flex items-center gap-2">
            <p className="text-muted-foreground">{t('admin.teams.totalTeams', {count: totalTeams})}</p>
            <Button onClick={onCreateTeam}>
                <Plus className="h-4 w-4 mr-2"/>
                {t('admin.teams.addTeam')}
            </Button>
        </div>
    );
}